export const UPDATE_WRONG_PROCESS_ORDER = {
    REQUEST: 'UPDATE_WRONG_PROCESS_ORDER_REQUEST',
    SUCCESS: 'UPDATE_WRONG_PROCESS_ORDER_SUCCESS',
    FAILED: 'UPDATE_WRONG_PROCESS_ORDER_FAILED',
};
